import React from 'react'
import BlockContent from '@sanity/block-content-to-react'

import Image from '@/image.js'

const AboutFounder = ({ content }) => {
  return (
    <div className='x image__text-wrapper founder py1'>
      <div className='container--l ma'>
        <div className='f jcb fw aic x image__text-flex'>
          <Image imageId={content.imageId} className='x image__image founder' />
          <div className='image__text founder pt15 px15 pb0'>
            <BlockContent blocks={content.description} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutFounder
